import {NgModule} from '@angular/core';
import {LocalStorageService} from './local-storage/local-storage.service';
import {SessionStorageService} from './session-storage/session-storage.service';

@NgModule({})
export class StorageModule {
    providers: [
        LocalStorageService,
        SessionStorageService
    ];
}
